import Img from 'gatsby-image';
import React from 'react';
import { TextImageStoryblok } from '../../../_shared/interfaces/storyblok';
import { getRichTextMarkup, StoryblokCommon } from '../../../lib/storyblok/storyblok';
// @ts-ignore (no types available for 'gatsby-storyblok-image')
import { getFluidGatsbyImage } from 'gatsby-storyblok-image';
import PlaceholderImage from '../../../images/16-9.gif';
import { isRichText } from '../../../lib/helpers/helpers';

import * as TextImageStylesHs from './text-image.hs.module.scss';
import * as TextImageStylesDr from './text-image.dr.module.scss';

import * as RichtextStyles from '../../../_scss/modules/_richtext.module.scss';

const TextImage = ({ blok, storyblokCommon }: { blok: TextImageStoryblok; storyblokCommon: StoryblokCommon }) => {
    const TextImageStyles = storyblokCommon.configuration.content.theme === 'dr' ? TextImageStylesDr : TextImageStylesHs;

    const getYouTubeUrl = (youTubeId: string): string => {
        return (
            'https://www.youtube-nocookie.com/embed/' +
            youTubeId +
            '?&playlist=' +
            youTubeId +
            '&autoplay=0' +
            '&cc_load_policy=3' +
            '&enablejsapi=0' +
            '&mute=0' +
            '&controls=2' +
            '&disablekb=0' +
            '&fs=1' +
            '&iv_load_policy=3' +
            '&loop=0' +
            '&modestbranding=1' +
            '&playsinline=1' +
            '&showinfo=0' +
            '&rel=0&'
        );
    };

    const getMedia = (position: 'left' | 'right'): React.ReactElement | undefined => {
        if (blok.image_position === position) {
            if (blok.image?.filename) {
                return getImage(blok.image.filename, blok.image.alt);
            } else if (blok.youtube_video_id) {
                return getVideo(blok.youtube_video_id);
            }
        }
        return undefined;
    };

    const getImage = (filename: string, alt: string | undefined): React.ReactElement => {
        return (
            <div className={TextImageStyles.image}>
                <Img fluid={getFluidGatsbyImage(filename)} alt={alt} />
            </div>
        );
    };

    const getVideo = (videoId: string): React.ReactElement => {
        return (
            <div className={TextImageStyles.youtube}>
                <img src={PlaceholderImage} alt="" />
                <iframe title="YouTube" src={getYouTubeUrl(videoId)} frameBorder="0" allowFullScreen={true} />
            </div>
        );
    };

    return (
        <div
            className={[
                TextImageStyles.textImage,
                blok.image?.filename || blok.youtube_video_id
                    ? blok.image_position === 'right'
                        ? TextImageStyles.right
                        : TextImageStyles.left
                    : '',
            ].join(' ')}
            style={{ padding: blok.padding ? '0 80px' : undefined }}
        >
            {getMedia('left')}
            <div className={TextImageStyles.content}>
                <div className={TextImageStyles.headline}>
                    {isRichText(blok.richheadline) ? (
                        <div dangerouslySetInnerHTML={getRichTextMarkup(blok.richheadline)} />
                    ) : blok.sub_component ? (
                        <h5>{blok.headline}</h5>
                    ) : (
                        <h4>{blok.headline}</h4>
                    )}
                </div>
                <div className={RichtextStyles.richtext} dangerouslySetInnerHTML={getRichTextMarkup(blok.copytext)} />
            </div>
            {getMedia('right')}
        </div>
    );
};

export default TextImage;
